import { render, staticRenderFns } from "./contractor-history-details.view.vue?vue&type=template&id=64ab64b5&class=fixed-header&"
import script from "./contractor-history-details.view.vue?vue&type=script&lang=js&"
export * from "./contractor-history-details.view.vue?vue&type=script&lang=js&"
import style0 from "./contractor-history-details.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
